import React from "react";
import styles from "./AuthLayout.module.scss";
import BorderlyLogo from "../../icons/borderly-plus-white-logo.svg";
import ErrorModal from "../../modals/ErrorModal";
import Button from "../../components/Button/Button";
import { updateLoggedIn } from "../../redux/authStore";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  clearLoginUiState,
  clearOrgContext,
  clearSessionToken,
} from "../../utils/auth";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../../components/LanguageSwitcher/LanguageSwitcher";

const AuthLayout = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation();

  const handleLogOut = () => {
    clearSessionToken(); // clears LS + cookie
    clearOrgContext(); // clears org_id LS + cookie
    clearLoginUiState(); // /login shows the email form again
    dispatch(updateLoggedIn(false));
  };

  const isAuthSelectionPage =
    location.pathname === "/login" || location.pathname === "/";
  const isWelcomePage = location.pathname === "/";

  return (
    <div className={styles.background}>
      <div className={styles.topBar}>
        <LanguageSwitcher onLightBackground />
        {/* Show the logout button only on authenticated pages (not on login or welcome) */}
        {!isAuthSelectionPage && (
          <Button
            text={t("authLayout.logout")}
            className={styles.button}
            onClick={handleLogOut}
          />
        )}
      </div>
      {!isAuthSelectionPage && (
        <img
          src={BorderlyLogo}
          alt={t("authLayout.logoAlt")}
          className={styles.logo}
        />
      )}
      <div
        className={isWelcomePage ? `${styles.box} ${styles.boxWide}` : styles.box}
      >
        {children}
      </div>
      <ErrorModal />
    </div>
  );
};

export default AuthLayout;
